// extracted by mini-css-extract-plugin
export var button = "_97-7";
export var buttonRow = "_97-6";
export var fadeIn = "_97-1";
export var gradient = "_97-0";
export var panel = "_97-2";
export var panelIn = "_97-3";
export var subtitle = "_97-5";
export var title = "_97-4";